import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Setup API base URL
const API = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

// Set token in headers
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// Fetch albums thunk
export const fetchAlbums = createAsyncThunk<
  any,
  { customerId: string | null },
  { rejectValue: string }
>('albums/fetchAlbums', async ({ customerId }, { rejectWithValue }) => {
  try {
    const response = await API.get(`/albums?customerId=${customerId}`);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch albums');
  }
});

// Create album thunk
export const createAlbums = createAsyncThunk<
  any,
  {
    title: string;
    thumbnail: File | string | null;
    description: string;
    usedToken: number;
    accessType: string;
    likes: number;
    tags: string[];
    sharedWith: string[];
    downloadable: boolean;
    status: string;
    customerId: string | null;
  },
  { rejectValue: string }
>('albums/createAlbums', async (albumData, { rejectWithValue }) => {
  try {
    const response = await API.post('/albums/add', albumData);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to create album');
  }
});

export const shareAlbum = createAsyncThunk(
  'album/shareAlbum',
  async ({albumId, userId }: { albumId: any, userId: string }, { rejectWithValue }) => {
  try {
    const response = await API.post(`/share/${albumId}/${userId}`);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to share album');
  }
});

export const verifyAlbum = createAsyncThunk(
  'album/VerifyAlbum',
  async ({albumId, verifyId }: { albumId: any, verifyId: string }, { rejectWithValue }) => {
  try {
    const response = await API.post(`/verify/${albumId}/${verifyId}`);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to verify album');
  }
});

export const InviteAlbum = createAsyncThunk(
  'album/InviteAlbum',
  async ({albumId, verifyId }: { albumId: any, verifyId: string }, { rejectWithValue }) => {
  try {
    const response = await API.post(`/invite/${albumId}/${verifyId}`);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to invite album');
  }
});